export default function setTime23_59_59(dateObject: Date) {
  const date = new Date(dateObject);
  date.setHours(23);
  date.setMinutes(59);
  date.setSeconds(59);
  return date;
}
